$('body').on('focusout', '#userAddress_zip', function () {
    $.ajax({
        url: $(this).attr('data-url'),
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            cp7: $(this).val()
        },
        dataType: 'JSON',
        success: function (data) {
            $('#userAddress_city').val(data.city);
        }
    });
});

$('body').on('click', '#userAddress_geolocation', function () {
    $.ajax({
        url: $(this).attr('data-action'),
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            latitude: window.geolocation.latitude,
            longitude: window.geolocation.longitude
        },
        dataType: 'JSON',
        success: function (data) {
            $('#userAddress_city').val(data.city);
            $('#userAddress_zip').val(data.zip);
        }
    });
});


$('body').on('click', '.btn-delete-account', function () {
    $('#delete-account').submit();
});
